import { cn } from "@/lib/utils/cn";

/**
 * Classe de botão local — o portal das imobiliárias não tem primitiva `Button`
 * (usa `<button>` cru). Espelha as variantes que a feature precisa (filtros,
 * paginação, ações), reusando os tokens do tema. Serve para `<button>` e `<a>`.
 */
type Variant = "primary" | "secondary" | "ghost";

const base =
  "inline-flex items-center gap-1.5 rounded-lg font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50";

const bySize = "h-8 px-2.5 text-[12.5px]";

const byVariant: Record<Variant, string> = {
  primary: "bg-brand-600 text-white hover:bg-brand-700",
  secondary: "border border-border bg-white text-ink hover:bg-bg",
  ghost: "text-ink hover:bg-bg",
};

export function buttonClass(variant: Variant = "secondary"): string {
  return cn(base, bySize, byVariant[variant]);
}
